export default "__VITE_ASSET__KiuBSkxd__"